import { Component, OnInit } from '@angular/core';

import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

import { NewsService } from '../../services/newsService';
import { uploadService } from '../../services/uploadService';
import { Upload } from '../../entities/upload';

@Component({
  selector: 'app-edit-news',
  templateUrl: './edit-news.component.html',
  styleUrls: ['./edit-news.component.css']
})
export class EditNewsComponent implements OnInit {

  idd;
  tempData;
  url: any;
  //filesToUpload: any[] = [];
  filesToUpload: any;
  currentUpload: Upload;
  currentUpload1: Upload;
  currentUpload2: Upload;
  currentUpload3: Upload;
  currentUpload4: Upload;
  IdNews;
  HeadNews;
  TitleNews;
  TypeNewspromotion;
  detailNews1;
  detailNews2;
  detailNews3;
  detailNews4;
  constructor(private _location: Location, private route: ActivatedRoute, private nsv: NewsService, private uSv: uploadService) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.idd = params['id'];
    })
    this.tempData = this.nsv.getNewsPromotionId(this.idd)

    if (this.tempData != null) {
      sessionStorage.setItem("is_reloaded_new", JSON.stringify(this.tempData))
    } else {
      this.tempData = JSON.parse(sessionStorage.getItem("is_reloaded_new"))
    }
    this.IdNews = this.tempData.id;
    this.HeadNews = this.tempData.Head;
    this.TitleNews = this.tempData.TitleNews;
    this.TypeNewspromotion = this.tempData.type;
    this.detailNews1 = this.tempData.detail1;
    this.url = this.tempData.photoTitle;
  }
  fileChangeEvent(event) {
    if (event.target.files && event.target.files[0] && event.target.files.length > 0) {
      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.url = event.target.result;
        //console.log(this.url)
      }
      reader.readAsDataURL(event.target.files[0]);
    }
      this.filesToUpload = event.target.files;
  }
  backClicked() {
    this._location.back();
  }
  Editnews() {
    
    if(this.filesToUpload !=null ){
      let file = this.filesToUpload.item(0)
      this.currentUpload = new Upload(file)
      let dataUpdate = {
          id:this.IdNews,
          Head: this.HeadNews,
          TitleNews: this.TitleNews,
          detail1: this.detailNews1,
          type: this.TypeNewspromotion,
          photoTitle: '',
          photo1: '',
          photo2: '',
          photo3: '',
          photo4: ''
      }
      //console.log("test1",dataUpdate)
      this.uSv.upDateNews(dataUpdate, this.currentUpload, this.idd)

      this.tempData = this.nsv.getNewsPromotionId(this.idd)

      if (this.tempData != null) {
        sessionStorage.setItem("is_reloaded_new", JSON.stringify(this.tempData))
      } else {
        this.tempData = JSON.parse(sessionStorage.getItem("is_reloaded_new"))
      }

      this.IdNews = this.tempData.id;
      this.HeadNews = this.tempData.Head;
      this.TitleNews = this.tempData.TitleNews;
      this.TypeNewspromotion = this.tempData.type;
      this.detailNews1 = this.tempData.detail1;
      this.url = this.tempData.photoTitle;
    }else{
      let dataUpdate = {
          id:this.IdNews,
          Head: this.HeadNews,
          TitleNews: this.TitleNews,
          detail1: this.detailNews1,
          type: this.TypeNewspromotion,
          photoTitle: this.url,
          photo1: '',
          photo2: '',
          photo3: '',
          photo4: ''
      }
      //console.log("test2",dataUpdate)
      this.nsv.updateNews(dataUpdate,this.IdNews);

      this.tempData = this.nsv.getNewsPromotionId(this.idd)

      if (this.tempData != null) {
        sessionStorage.setItem("is_reloaded_new", JSON.stringify(this.tempData))
      } else {
        this.tempData = JSON.parse(sessionStorage.getItem("is_reloaded_new"))
      }
      this.IdNews = this.tempData.id;
      this.HeadNews = this.tempData.Head;
      this.TitleNews = this.tempData.TitleNews;
      this.TypeNewspromotion = this.tempData.type;
      this.detailNews1 = this.tempData.detail1;
      this.url = this.tempData.photoTitle;
    }
  }
  // EditNews() {
  //   if (this.filesToUpload.length == 1) {
  //     console.log("t1")
  //     let file = this.filesToUpload[0].item(0)
  //     this.currentUpload = new Upload(file)

  //     let dataUpdate = {
  //       Head: this.HeadNews,
  //       TitleNews: this.TitleNews,
  //       type: this.TypeNewspromotion,
  //       photoTitle: '',
  //       photo1: '',
  //       photo2: '',
  //       photo3: '',
  //       photo4: '',
  //       detail1: this.detailNews1,
  //       detail2: this.detailNews2,
  //       detail3: this.detailNews3,
  //       detail4: this.detailNews4,
  //     }
  //     this.uSv.upDateNews(dataUpdate,this.currentUpload,this.idd)
  //   } else if (this.filesToUpload.length == 2) {
  //     console.log("t2")
  //     let file = this.filesToUpload[0].item(0)
  //     let file1 = this.filesToUpload[1].item(0)
  //     this.currentUpload = new Upload(file)
  //     this.currentUpload1 = new Upload(file1)

  //     let dataUpdate = {
  //       Head: this.HeadNews,
  //       TitleNews: this.TitleNews,
  //       type: this.TypeNewspromotion,
  //       photoTitle: '',
  //       photo1: '',
  //       photo2: '',
  //       photo3: '',
  //       photo4: '',
  //       detail1: this.detailNews1,
  //       detail2: this.detailNews2,
  //       detail3: this.detailNews3,
  //       detail4: this.detailNews4,
  //     }
  //     this.uSv.upDateNews1(dataUpdate,this.currentUpload,this.currentUpload1,this.idd)
  //   } else if (this.filesToUpload.length == 3) {
  //     console.log("t3")
  //     let file = this.filesToUpload[0].item(0)
  //     let file1 = this.filesToUpload[1].item(0)
  //     let file2 = this.filesToUpload[2].item(0)
  //     this.currentUpload = new Upload(file)
  //     this.currentUpload1 = new Upload(file1)
  //     this.currentUpload2 = new Upload(file2)

  //     let dataUpdate = {
  //       Head: this.HeadNews,
  //       TitleNews: this.TitleNews,
  //       type: this.TypeNewspromotion,
  //       photoTitle: '',
  //       photo1: '',
  //       photo2: '',
  //       photo3: '',
  //       photo4: '',
  //       detail1: this.detailNews1,
  //       detail2: this.detailNews2,
  //       detail3: this.detailNews3,
  //       detail4: this.detailNews4,
  //     }
  //     this.uSv.upDateNews2(dataUpdate,this.currentUpload,this.currentUpload1,this.currentUpload2,this.idd)
  //   } else if (this.filesToUpload.length == 4) {
  //     console.log("t4")
  //     let file = this.filesToUpload[0].item(0)
  //     let file1 = this.filesToUpload[1].item(0)
  //     let file2 = this.filesToUpload[2].item(0)
  //     let file3 = this.filesToUpload[3].item(0)
  //     this.currentUpload = new Upload(file)
  //     this.currentUpload1 = new Upload(file1)
  //     this.currentUpload2 = new Upload(file2)
  //     this.currentUpload3 = new Upload(file3)

  //     let dataUpdate = {
  //       Head: this.HeadNews,
  //       TitleNews: this.TitleNews,
  //       type: this.TypeNewspromotion,
  //       photoTitle: '',
  //       photo1: '',
  //       photo2: '',
  //       photo3: '',
  //       photo4: '',
  //       detail1: this.detailNews1,
  //       detail2: this.detailNews2,
  //       detail3: this.detailNews3,
  //       detail4: this.detailNews4,
  //     }
  //     this.uSv.upDateNews3(dataUpdate,this.currentUpload,this.currentUpload1,this.currentUpload2,this.currentUpload3,this.idd)
  //   } else if (this.filesToUpload.length == 5) {
  //     console.log("t5")
  //     let file = this.filesToUpload[0].item(0)
  //     let file1 = this.filesToUpload[1].item(0)
  //     let file2 = this.filesToUpload[2].item(0)
  //     let file3 = this.filesToUpload[3].item(0)
  //     let file4 = this.filesToUpload[4].item(0)
  //     this.currentUpload = new Upload(file)
  //     this.currentUpload1 = new Upload(file1)
  //     this.currentUpload2 = new Upload(file2)
  //     this.currentUpload3 = new Upload(file3)
  //     this.currentUpload4 = new Upload(file4)

  //     let dataUpdate = {
  //       Head: this.HeadNews,
  //       TitleNews: this.TitleNews,
  //       type: this.TypeNewspromotion,
  //       photoTitle: '',
  //       photo1: '',
  //       photo2: '',
  //       photo3: '',
  //       photo4: '',
  //       detail1: this.detailNews1,
  //       detail2: this.detailNews2,
  //       detail3: this.detailNews3,
  //       detail4: this.detailNews4,
  //     }
  //     this.uSv.upDateNews4(dataUpdate,this.currentUpload,this.currentUpload1,this.currentUpload2,this.currentUpload3,this.currentUpload4,this.idd)
  //   } else if (this.filesToUpload.length == 0) {
  //     let dataUpdate = {
  //       Head: this.HeadNews,
  //       TitleNews: this.TitleNews,
  //       type: this.TypeNewspromotion,
  //       detail1: this.detailNews1,
  //       detail2: this.detailNews2,
  //       detail3: this.detailNews3,
  //       detail4: this.detailNews4,
  //     }
  //     this.nsv.updateNews(dataUpdate, this.idd)
  //   }
  // }
}



// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/components/edit-news/edit-news.component.ts